export enum DayPeriod {
  AM = 'AM',
  PM = 'PM',
}

export interface Time12Hour {
  hour: number;        // 1-12
  minute: number;      // 0-59
  second: number;      // 0-59
  period: DayPeriod;
}

export class TimeConverter {
  static to24Hour(time12: Time12Hour): { hour: number; minute: number; second: number } {
    let hour24 = time12.hour % 12;
    if (time12.period === DayPeriod.PM) {
      hour24 += 12;
    }
    return {
      hour: hour24,
      minute: time12.minute,
      second: time12.second,
    };
  }

  static from24Hour(hour24: number, minute: number, second: number): Time12Hour {
    const period = hour24 >= 12 ? DayPeriod.PM : DayPeriod.AM;
    const hour12 = hour24 % 12;
    return {
      hour: hour12 === 0 ? 12 : hour12,
      minute,
      second,
      period,
    };
  }

  static isPm(period: DayPeriod): boolean {
    return period === DayPeriod.PM;
  }

  static fromBoolean(isPm: boolean): DayPeriod {
    return isPm ? DayPeriod.PM : DayPeriod.AM;
  }
}
